import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import MassUpdatePopup from "../components/list/MassUpdatePopup";
import ListHeader from '../components/list/ListHeader';
import TableUI from '../components/list/TableUI';
import FilterPannel from '../components/filter/FilterPannel';

import Const from '../util/Constants';
import CallAPI from '../api/CallAPI';
import KeyValueAPI from '../api/KeyValueAPI';
import CallPopup from '../components/call/CallPopup';
import Util from '../util/Util';
import withRouter from '../util/WithRouter';
import ImportExportAPI from '../api/ImportExportAPI';
import ViewController from '../controller/ViewController';
import HeaderViewList from '../components/list/HeaderViewList';
import DB from '../util/LocalDB';

class CallList extends React.Component {

  constructor(props) {
    super(props);
    const query = new URLSearchParams(props.location.search);
    let filters = query.get("filters") ? JSON.parse(query.get("filters")) : null;

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.call;

    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    this.views = ViewController.getViews(Const.Call);
    this.view = this.views.find((view) => view.id === (filters ? 0 : cView.call ? cView.call : 0));
    if (!this.view) {
      this.view = this.views.find(view => view.type === 0);
    }

    this.actions = DB.getActions(Const.Call);

    if (!filters) {
      const list = reactLocalStorage.getObject(Const.ListCall);
      filters = list && list.filters ? list.filters : filters;
    }
    this.setList(filters);

    this.data = { calls: [], count: 0 };
    this.state = { massEmail: false, massSMS: false, inApiCall: true, isFilterOpen: false, massUpdate: false, };

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);

    this.selected = [];
  }

  componentDidMount() { if (this.List) this.loadCalls(); }

  setList = filters => {
    let modelfields = reactLocalStorage.getObject(Const.FieldList);
    let lists = modelfields.call;
    if (!lists) {
      lists = [];
      modelfields = { ...modelfields, call: lists };
    }

    const fields = ['model', 'date_time', 'responsible_person', 'feedback', 'comment', 'complete',
      'created_by', 'created_date'];
    this.list = lists.find(list => list.view === this.view.id);

    if (!this.list) {
      this.list = { view: this.view.id };
      modelfields = { ...modelfields, call: [...modelfields.call, this.list] };
    }

    this.list.fields = this.view.fields && this.view.fields.length > 0 && this.view.fields[0] ? this.view.fields
      : this.list.fields ? this.list.fields : fields;
    this.list.filters = filters ? filters : this.list.filters ? this.list.filters : [];

    this.list.pagination = this.list.pagination ? this.list.pagination : {};
    this.list.pagination.currentPage = this.list.pagination.currentPage ? this.list.pagination.currentPage : 1;
    this.list.pagination.pageCount = this.list.pagination.pageCount ? this.list.pagination.currentPage : 1;
    this.list.pagination.perPage = this.list.pagination.perPage ? this.list.pagination.perPage : 10;

    this.list.sorting = this.list.sorting ? this.list.sorting : {};
    this.list.sorting.field = this.view.sortField ? this.view.sortField : 'date_time';
    this.list.sorting.order = this.view.sortOrder ? this.view.sortOrder : -1;

    if (this.ListRestrict) {
      this.list.fields = this.view && this.view.fields && this.view.fields.length > 0 ? this.view.fields : fields;
    }

    this.list.fields = this.list.fields.filter((field) => {
      if (!field) {
        return false;
      }

      if (field.includes(Const.Opt))
        return (
          this.model.fields[field.split(Const.Opt)[0]] &&
          this.model.fields[field.split(Const.Opt)[0]].visible === Const.True
        );
      else
        return (
          this.model.fields[field] &&
          this.model.fields[field].visible === Const.True
        );
    });

    reactLocalStorage.setObject(Const.FieldList, modelfields);
  };

  saveListFields = list => {
    let fieldList = reactLocalStorage.getObject(Const.FieldList);
    if (!fieldList) fieldList = {};
    fieldList = { ...fieldList, call: list };
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, fieldList, () => { });
  };

  saveListSort = sort => {
    let fieldList = reactLocalStorage.getObject(Const.FieldList);
    if (!fieldList) fieldList = {};
    fieldList = { ...fieldList, call_sort: sort };
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, fieldList, () => { });
  };

  loadCalls = () => {
    reactLocalStorage.setObject(Const.ListCall, this.list);
    const mainFilters = ViewController.getRestrictionsView(Const.Call);
    const filters = ViewController.filters([...this.list.filters], this.view.filters, mainFilters, this.Restrict);
    this.setState({ ...this.state, inApiCall: true, popup: '' });
    CallAPI.getList({ ...this.list, filters }, this.onReceived, this.onFail);
  };

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    this.data.calls = res.data;
    this.data.count = res.count;
    this.list.pagination.pageCount = Math.ceil(res.count / this.list.pagination.perPage);
    this.setState({ ...this.state, inApiCall: false });
  };

  onPageChange = currentPage => {
    this.list.pagination.currentPage = currentPage;
    this.loadCalls();
  };

  onPerPageChange = perPage => {
    this.list.pagination.perPage = perPage;
    this.loadCalls();
  };

  onFieldSelection = fields => {
    this.list.fields = fields;
    reactLocalStorage.setObject(Const.ListCall, this.list);
    this.saveListFields(fields);
  };

  onOrderChange = (field, order) => {
    this.list.sorting = { field, order };
    reactLocalStorage.setObject(Const.ListCall, this.list);
    this.saveListSort(this.list.sorting);
    this.loadCalls();
  };

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    reactLocalStorage.setObject(Const.ListCall, this.list);
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  };
  closeFilter = () => this.setState({ ...this.state, isFilterOpen: false });
  onFilterChange = filters => { this.list.filters = filters; this.loadCalls(); };

  onAddEdit = index => this.setState({ ...this.state, call: this.data.calls[index] });
  onPreview = index => {
    const call = this.data.calls[index];
    if (call.model_no === Const.Lead) {
      this.props.navigate(`/lead/preview/${call.model_id}`);
    } else if (call.model_no === Const.Contact) {
      this.props.navigate(`/contact/preview/${call.model_id}`);
    }
  };
  onDelete = index => Util.confirmAlert('Delete', 'Are you sure you want to delete',
    'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      CallAPI.delete(this.data.calls[index].id, this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Call deleted successfully', 'success');
    this.loadCalls();
  };

  hidePopUp = () => this.setState({ ...this.state, call: null });

  export = fields => Util.confirmAlert('Export', `Are you sure you want to export to with `
    + ` applied filters ? `, 'Export', 'Cancel', () => {
      this.setState({ ...this.state, inApiCall: true });
      const filters = ViewController.filters([...this.list.filters], this.view.filters, this.Restrict);
      ImportExportAPI.exportModel(Const.Call, filters, this.list.sorting, this.data.count, fields, this.model.model_no,
        this.onExport, this.onFail);
    });
  onExport = () => {
    this.setState({ ...this.state, inApiCall: false });
    Util.showNotification('Successful', 'Call Exported in progress.'
      + ' Please visit Settings', 'success');
  };

  onTabClick = (view) => {
    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    cView.call = view;
    reactLocalStorage.setObject(Const.CurrentViews, cView);
    if (this.view.id !== view) {
      this.view = this.views.find((item) => item.id === view);
      this.setList();
      this.loadCalls();
    }
    this.setState({ ...this.state, isFilterOpen: false });
  };

  onSelect = (id) => {
    this.selected.push(id);
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onRemove = (id) => {
    this.selected = this.selected.filter((item) => id !== item);
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onSelectAll = () => {
    for (let i = 0; i < this.data.calls.length; i++) {
      const id = this.selected.find(item => item === this.data.calls[i].id);
      if (!id) this.selected.push(this.data.calls[i].id);
    }
    this.setState({ ...this.state, selected: !this.state.selected });
  };
  onRemoveAll = () => {
    for (let i = 0; i < this.data.calls.length; i++) {
      this.selected = this.selected.filter(item => item !== this.data.calls[i].id);
    }
    this.setState({ ...this.state, selected: !this.state.selected });
  };

  showMassUpdate = () => {
    if (this.selected.length === 0) {
      Util.showNotification("Failure", "Please apply filters or Select Data", "danger");
    } else {
      this.setState({ ...this.state, massUpdate: !this.state.massUpdate });
    }
  };

  onMassUpdate = (updates) => {
    this.setState({ ...this.state, massUpdate: false, inApiCall: true });
    CallAPI.massUpdate(this.list, this.selected, updates, this.onMassUpdated, this.onFail);
  };

  onMassUpdated = () => {
    Util.showNotification('Successful', 'Call mass Updated successfull.', 'success');
    this.selected = [];
    this.loadCalls();
  };

  render() {
    if (!this.List) return null;

    return (
      <div>
        {this.state.massUpdate ?
          <MassUpdatePopup
            model={this.model}
            onUpdateChanged={this.onUpdateChanged}
            onMassUpdate={this.onMassUpdate}
            showMassUpdate={this.showMassUpdate}
          />
          : null
        }
        <CallPopup show={this.state.call} onHide={this.hidePopUp} call={this.state.call} reload={this.loadCalls} lead={{ firstname: this.state.call?.lead_first, lastname: this.state.call?.lead_last }} />

        <HeaderViewList views={this.views} view={this.view} onTabClick={this.onTabClick} />

        <ListHeader
          name={this.model.label_name} pagination={this.list.pagination} model={this.model}
          listCount={this.data.count} filterCount={this.list.filters.length}
          onPageChange={this.onPageChange} perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange} toggleFilter={this.toggleFilter}
          onAddClick={() => this.onAddEdit(0)} add={false} export={this.export}
          showMassUpdate={this.showMassUpdate} />

        <div className="container-fluid ">
          <div className="row">
            <TableUI
              data={this.data.calls}
              model={this.model}
              fields={this.list.fields}
              order={this.list.sorting}
              pagination={this.list.pagination}
              inApiCall={this.state.inApiCall}
              onFieldChange={this.onFieldChange}
              onOrderChange={this.onOrderChange}
              preview={true}
              update={this.Update}
              onAddEdit={this.onAddEdit}
              onPreview={this.onPreview}
              onDelete={this.onDelete}
              isFilterOpen={this.state.isFilterOpen}
              onFieldSelection={this.onFieldSelection}
              showMassUpdate={this.showMassUpdate}
              selected={this.selected}
              onSelect={this.onSelect}
              onRemove={this.onRemove}
              onSelectAll={this.onSelectAll}
              onRemoveAll={this.onRemoveAll}
              actions={this.actions} />

            <FilterPannel filters={this.list.filters} fields={this.model.fields}
              onFilterChange={this.onFilterChange} isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict}
              closeFilter={this.closeFilter} />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(CallList);